import { useCallback } from 'react';
import type { FolderDetailCategory } from 'shared/src/api/likedFolderService/getFolderDetailCategories';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { ALL_CATEGORY, type DeliveryToggleType, type FolderType } from '../constants';

interface UseLogClickDeliveryToggleParams {
  deliveryToggleType: DeliveryToggleType;
  folderType: FolderType;
  folderSno: number;
  listId: string | null;
  sortType: string;
  category: FolderDetailCategory | null;
}

export const useLogClickDeliveryToggle = ({
  deliveryToggleType,
  folderType,
  folderSno,
  listId,
  sortType,
  category,
}: UseLogClickDeliveryToggleParams) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    (isOn: boolean) => {
      const target = category ?? ALL_CATEGORY;
      logAnalyticsEvent({
        name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE',
        analytics: {
          IS_ON: isOn,
          LIST_ID: listId,
          TOGGLE_TYPE: deliveryToggleType,
          SORT_TYPE: sortType,
          CATEGORY_NAME: target.name,
          CATEGORY_SNO: target.sno.toString(),
          FOLDER_TYPE: folderType,
          FOLDER_SNO: folderSno.toString(),
        },
      });
    },
    [
      logAnalyticsEvent,
      deliveryToggleType,
      folderType,
      folderSno,
      listId,
      sortType,
      category,
    ],
  );
};
